import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

import type { FeatureData } from "../../features/Workflows"
import type { Deployment } from "../../types/generated/api/Deployment"
import type { DeploymentList } from "../../types/generated/api/DeploymentList"

type InitialStateType = {
  computedFeatures: FeatureData[]
  schemaFeatures: FeatureData[]
  constantFeatures: FeatureData[]
  currentProject: Deployment | DeploymentList | undefined
}

const initialState: InitialStateType = {
  computedFeatures: [],
  schemaFeatures: [],
  constantFeatures: [],
  currentProject: undefined,
}

/**
 * this slice used to store and update workflow schemas features (project schema mirror)
 * and computed features in all workflows to use them in different workflow component
 */
export const ProjectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    setComputedFeatures(state, action: PayloadAction<Array<FeatureData>>) {
      state.computedFeatures = action.payload
    },
    setSchemaFeatures(state, action: PayloadAction<Array<FeatureData>>) {
      state.schemaFeatures = action.payload
    },
    setConstantFeatures(state, action: PayloadAction<Array<FeatureData>>) {
      state.constantFeatures = action.payload
    },
    setCurrentProject: (state, action: PayloadAction<Deployment | DeploymentList | undefined>) => {
      state.currentProject = action.payload
    },
  },
})

export const { setComputedFeatures, setSchemaFeatures, setCurrentProject, setConstantFeatures } = ProjectSlice.actions
